/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateLocationResultFromDiscriminatorValue, createPaginatedListOfLocationSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateLocationCommand, serializeCreateLocationResult, type CreateLocationCommand, type CreateLocationResult, type PaginatedListOfLocationSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ItemRequestBuilderNavigationMetadata, ItemRequestBuilderRequestsMetadata, type ItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /locations
 */
export interface LocationsRequestBuilder extends BaseRequestBuilder<LocationsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.locations.item collection
     * @param id Unique identifier of the item
     * @returns {ItemRequestBuilder}
     */
     byId(id: Guid) : ItemRequestBuilder;
    /**
     * GetLocationsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfLocationSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<LocationsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfLocationSummary | undefined>;
    /**
     * CreateLocation
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateLocationResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateLocationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateLocationResult | undefined>;
    /**
     * GetLocationsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<LocationsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateLocation
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateLocationCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetLocationsByCustomer
 */
export interface LocationsRequestBuilderGetQueryParameters {
    customerId?: Guid;
    pageNumber?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const LocationsRequestBuilderUriTemplate = "{+baseurl}/locations{?PageNumber*,PageSize*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const LocationsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "customerId": "CustomerId",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const LocationsRequestBuilderNavigationMetadata: Record<Exclude<keyof LocationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: ItemRequestBuilderRequestsMetadata,
        navigationMetadata: ItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["%2Did"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const LocationsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: "{+baseurl}/locations?CustomerId={CustomerId}{&PageNumber*,PageSize*}",
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfLocationSummaryFromDiscriminatorValue,
        queryParametersMapper: LocationsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: LocationsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateLocationResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateLocationCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
